module.exports = __webpack_public_path__ + "img/17344049000164.af76a163.png";